var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSellArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 14,
    viewBox: "0 0 19 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.5002 7.02525C18.5002 6.43831 18.0532 5.96196 17.5002 5.96196C16.9472 5.96196 16.5002 6.43831 16.5002 7.02525V9.46763L12.2592 4.20647C11.9432 3.81305 11.4052 3.71948 10.9852 3.98743L6.72017 6.70839L2.26917 1.02829C1.91517 0.578518 1.28617 0.51472 0.85917 0.892189C0.43617 1.26753 0.37817 1.93847 0.73117 2.3893L5.73117 8.76905C6.04817 9.17204 6.59317 9.27092 7.01517 8.99978L11.2902 6.27244L15.3262 11.2784H12.5002C11.9472 11.2784 11.5002 11.7548 11.5002 12.3417C11.5002 12.9286 11.9472 13.405 12.5002 13.405H17.5002C17.6242 13.405 17.7472 13.3763 17.8642 13.3263C17.9132 13.3061 17.9512 13.2721 17.9962 13.2455C18.0482 13.2125 18.1042 13.1923 18.1502 13.1487C18.1602 13.1402 18.1642 13.1275 18.1732 13.1179C18.2282 13.0647 18.2662 12.9999 18.3082 12.935C18.3412 12.884 18.3802 12.8393 18.4032 12.784C18.4282 12.7277 18.4362 12.6649 18.4502 12.6043C18.4692 12.5299 18.4902 12.4576 18.4922 12.381C18.4932 12.3672 18.5002 12.3555 18.5002 12.3417V7.02525Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSellArrow);
export default __webpack_public_path__ + "static/media/sell-arrow.6c3ce3c37bf01effee29ade6daf0205c.svg";
export { ForwardRef as ReactComponent };